<template>
    <div>
        <tab name="1"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="账期" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker v-model="datetimerange" type="daterange" start-placeholder="开始日期"
                            end-placeholder="结束日期" class="fl" size="small" value-format="yyyyMMdd" align="right" unlink-panels>
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/finance/exportStatementList')" type="primary" icon="el-icon-download" size="small"
                @click="download" :loading="downLoading">导出对账单列表</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="time" label="对账日期" min-width="100"></el-table-column>
                <el-table-column prop="status" label="对账状态" min-width="90">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">下载中</span>
						<el-tag size="mini" type="danger" v-else-if="scope.row.status == 2" @click="afresh(scope.row)" class="hand">下载失败</el-tag>
                        <span v-else-if="scope.row.status == 3">对账中</span>
                        <span v-else class="color-success">对账完成</span>
                    </template>
                </el-table-column>
                <el-table-column prop="platformTotalAmount" label="支付平台总收入" min-width="110"></el-table-column>
                <el-table-column prop="platformPoundage" label="支付平台手续费" min-width="110"></el-table-column>
                <el-table-column prop="billSuccessAmount" label="对账成功金额" min-width="110"></el-table-column>
                <el-table-column prop="platformTotalNum" label="支付平台总笔数" min-width="110"></el-table-column>
                <el-table-column prop="billSuccessTotalNum" label="对账成功总笔数" min-width="110"></el-table-column>
                <el-table-column prop="platformRedundantNum" label="支付平台多出" min-width="100"></el-table-column>
                <el-table-column prop="redundantNum" label="秀动订单多出" min-width="100"></el-table-column>
                <el-table-column prop="inconsistentAmountNum" label="金额不一致" min-width="90"></el-table-column>
                <el-table-column prop="repeatNum" label="重复支付"></el-table-column>
                <el-table-column prop="createTime" label="任务生成时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.status == 5"
                            type="text"
                            size="small"
                            @click="view(scope.row.time)"
                            >详情</el-button
                        >
                        <el-button
                            v-else-if="scope.row.status == 2"
                            type="text"
                            size="small"
                            @click="upload(scope.row.time)"
                            >手动上传</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <manual-upload ref="manualUpload" @onUpdate="getDataList"></manual-upload>
    </div>
</template>
<script>
// import {downloadFileTmp} from '@/assets/js/commonApi.js';
import ManualUpload from './components/manualUpload.vue';
import Tab from '../components/tab.vue';
const defaultParams = {
    pageNo: 1,
    timeType: 1,
    startTime: '',
    endTime: '',
}
export default {
    components:{ManualUpload,Tab},
    data() {
        const endTime = this.$utils.formatDate((new Date().getTime()), 'yyyyMMdd');
        const startTime = '20220801';//this.$utils.formatDate((new Date().getTime() - 3600 * 1000 * 24 * 7), 'yyyyMMdd');
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                timeType: parseInt(this.$route.query.timeType || 1),
                // startTime: this.$route.query.startTime || startTime,
                // endTime: this.$route.query.endTime || endTime,
            },
            listLoading: true,
            datetimerange: [this.$route.query.startTime || startTime, this.$route.query.endTime || endTime],
            downLoading: false,
        }
    },
    computed:{
        userInfo(){
            return this.$store.state.userInfo;
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/finance/statementList",
                method: "POST",
                params: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导出
        async download(){
            // let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url: "/finance/exportStatementList",
                method: "POST",
                params: {
                    ...this.params
                },
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg} = res.data;
            if(state == 1){
                // filePath = result.url;
                this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                    confirmButtonText: '立即查看',
                    cancelButtonText: '稍后再看',
                    type: 'success',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    this.$router.push({path:'/workbench/downloadList'})
                }).catch(() => {})
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            // await downloadFileTmp(filePath,`收款对账单_${this.userInfo.name}_${this.params.startTime}_${this.params.endTime}.`+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        //查看详情
        view(time){
            this.$router.push({
                path: `/finance/statement/detail?time=${time}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //手动上传
        upload(time){
            this.$refs.manualUpload.show(time);
        },
		afresh(data){
		    this.$confirm(`失败：${data.wrongReason} 。是否需要尝试重新对账？`, '提示', {
				confirmButtonText: '是',
				cancelButtonText: '否',
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then( () => {
		        this.$request({
		            url: "/finance/retry",
		            method: "POST",
		            params: {
		                time:data.time
		            },
		        }).then(res=> {
		            let { state, msg } = res.data;
		            if (state == 1) {
		                this.$message.success("操作成功");
		                this.getDataList();
		            }else{
		                this.$message.error(msg || "请求失败");
		            }
		        }).catch( () => {
		            this.$message.error("操作失败");
		        })
		    }).catch( () => {})
		}
		
    }
}
</script>

<style lang="scss" scoped>
.hand{
	cursor: pointer;
}
</style>